import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { NotificationCategory, UserNotification } from '@app/core/modules/user-notification/models/UserNotification';

@Component({
  selector: 'audako4-user-notification',
  templateUrl: './user-notification.component.html',
  styleUrls: ['./user-notification.component.scss']
})
export class UserNotificationComponent implements OnInit {
  public types = NotificationCategory;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: UserNotification) {}

  ngOnInit() {}
}
